import Axios from "axios";
import {
  SET_EDITING_INV_CUSTOMER_KPI_ASSIGNMENT_LIST,
  SET_INV_CUSTOMER_KPI_ASSIGNMENT_LIST,
  UNSET_EDITING_INV_CUSTOMER_KPI_ASSIGNMENT_LIST,
  UNSET_INV_CUSTOMER_KPI_ASSIGNMENT_LIST,
} from "@/store/mutation-types";
import { 
  getInvCustomerKpiAssignmentsList,
  saveInvCustomerKpiAssignment,
  getInvCustomerKpiAssignmentById
} from "@/store/api";

const state = {
  getInvCustomerKpiAssignmentsList: [],
  getEditingInvCustomerKpiAssignment: null,
};

const getters = {
  getInvCustomerKpiAssignmentsList(state) {
    return state.getInvCustomerKpiAssignmentsList;
  },
  getEditingInvCustomerKpiAssignment(state) {
    return state.getEditingInvCustomerKpiAssignment;
  },
};

const mutations = {
  [SET_INV_CUSTOMER_KPI_ASSIGNMENT_LIST](state, data) {
    state.getInvCustomerKpiAssignmentsList = data;
  },
  [UNSET_INV_CUSTOMER_KPI_ASSIGNMENT_LIST](state) {
    state.getInvCustomerKpiAssignmentsList = [];
  },
  [SET_EDITING_INV_CUSTOMER_KPI_ASSIGNMENT_LIST](state, data) {
    state.getEditingInvCustomerKpiAssignment = data;
  },
  [UNSET_EDITING_INV_CUSTOMER_KPI_ASSIGNMENT_LIST](state) {
    state.getEditingInvCustomerKpiAssignment = [];
  },
};

const actions = {

  saveInvCustomerKpiAssignment({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveInvCustomerKpiAssignment, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },
  
  getInvCustomerKpiAssignmentsList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getInvCustomerKpiAssignmentsList, {params:data})
        .then(function (response) {
          commit('SET_INV_CUSTOMER_KPI_ASSIGNMENT_LIST', response.data.data)
          resolve(response.data.data);
        })
        .catch(function (error) {
          commit('UNSET_INV_CUSTOMER_KPI_ASSIGNMENT_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getInvCustomerKpiAssignmentById({ commit }, data) {
    const getInvCustomerKpi = `${getInvCustomerKpiAssignmentById}/${data}`;
    commit("SET_LOADING", {color: "primary"});  
    return new Promise((resolve, reject) => {
      Axios.get(getInvCustomerKpi)
        .then((response) => {
          resolve(response.data.code);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};  

export default {
  state,
  getters,
  actions,
  mutations,
};
